<template>
  <div id="file-brows">
    <div class="content">
      <div class="left-box">
        <el-table
          ref="singleTable"
          style="border:0;"
          :data="pathData[listPage]"
          highlight-current-row
          border=""
          height="calc(100% - 32px - var(--padding))"
          @row-click="rootClick"
        >
          <el-table-column label="目录列表">
            <template slot-scope="scope">
              <span style="cursor: pointer;" class="path">{{ scope.row }}</span>
            </template>
          </el-table-column>
        </el-table>
        <page-trun
          style="padding: 0 var(--padding) var(--padding);justify-content: center;"
          :page="{ pageIndex: listPage + 1, hasMore: false }"
          :queryData="pathData"
          @pageTrun="listTrun"
        ></page-trun>
      </div>
      <div class="right-box">
        <div class="button-group">
          <div class="filepath">
            <div>当前路径：</div>
            <div>
              <template v-for="(url, i) in pathUrl">
                <span :key="i" class="path-name" @click="pathClick(url.path, i)"
                  >{{ i ? "/" : "" }}{{ url.name }}</span
                >
              </template>
            </div>
          </div>
          <el-input
            size="small"
            placeholder="文件名匹配规则"
            v-model="filterForm.value"
            class="filter-input"
            @keyup.enter.native="onSubmit"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="onSubmit"
            ></el-button>
          </el-input>
          <el-button
            size="small"
            @click="newDialog = true"
            type="primary"
            style="margin-left:10px;"
            >新建文件夹</el-button
          >

          <el-button size="small" @click="uploadDialog = true">
            上传文件
          </el-button>
          <el-dropdown @command="piClick">
            <el-button size="small" style="margin: 0 8px;">
              批量操作
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="del">
                <i class="el-icon-delete"></i> 删除
              </el-dropdown-item>
              <el-dropdown-item command="dwn">
                <i class="el-icon-download"></i> 下载
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button size="small" @click="refush">
            刷 新
          </el-button>
        </div>
        <el-table
          v-loading="loading"
          :data="tableData"
          height="calc(100% - 32px * 2 - var(--padding))"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="filename" label="文件名" min-width="320">
            <template slot-scope="scope">
              <span
                v-if="scope.row.dir"
                @click="folderClick(scope.row.path)"
                class="path"
              >
                <i class="el-icon-ga-wjgl"></i>
                {{ scope.row.filename }}
              </span>
              <span v-else>{{ scope.row.filename }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="size"
            label="文件大小"
            min-width="140"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="owner"
            label="所属用户"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="group"
            label="所属组"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="permission"
            label="权限"
            min-width="110"
          ></el-table-column>
          <el-table-column
            prop="createtime"
            label="创建时间"
            min-width="200"
          ></el-table-column>
          <el-table-column
            label="操作"
            width="70"
            align="center"
            #default="{row}"
          >
            <el-dropdown
              placement="bottom"
              @command="handleCommand($event, row)"
              szie="small"
            >
              <i class="el-icon-more icon-button"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="copyPath">
                  <i class="el-icon-ga-fuzhi"></i> 复制路径
                </el-dropdown-item>
                <el-dropdown-item command="d" :disabled="row.dir">
                  <i class="el-icon-ga-xiazai1"></i> 下载
                </el-dropdown-item>
                <el-dropdown-item command="del">
                  <i class="el-icon-delete"></i> 删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-table-column>
        </el-table>
        <page-trun
          :disabled="loading"
          :page="page"
          :queryData="queryData"
          :path="`${rootPath}_${filterValue}_`"
          @pageTrun="pageTrun"
        ></page-trun>
      </div>
    </div>
    <file-dialog
      :newDialog="newDialog"
      :uploadDialog="uploadDialog"
      :path="rootPath"
      @closeDialog="closeDialog"
      @refush="refush"
    />
  </div>
</template>

<script>
import Clipboard from "clipboard";
import {
  Delete,
  Download,
  paging,
  DeleteArr,
  DeletePrompt
} from "@/utils/index";
import dialog from "./dialog.vue";

export default {
  name: "Filebrowsing",
  data() {
    return {
      pathData: [], // 根路径数组
      newDialog: false, // 新建目录dialog
      uploadDialog: false, // 上传文件dialog
      rootPath: "",
      queryData: {},
      filterForm: {
        value: "" // 文件过滤
      },
      loading: false,
      pathRouter: [],
      filterValue: "",
      selValue: "", // 选中值
      multipleSelection: [], // 选中行
      lcbtn: false, // 新建文件夹model控制
      url: [], // 面包削
      dataUrl: "",
      page: {
        pageIndex: 1,
        hasMore: false,
        limit: 20
      },
      listPage: 0
    };
  },
  mounted() {
    this.getPathData();
    let path = this.$store.state.jumpToPath;
    if (path) {
      if (path === "refush") {
        this.getPathData();
        this.queryData = {};
      } else {
        this.getPathData(path);
        this.$store.dispatch("setJumpPath", null);
      }
    }
  },
  computed: {
    tableData() {
      let data = this.queryData[
        `${this.rootPath}_${this.filterValue}_${this.page.pageIndex}`
      ];
      if (data) {
        return JSON.parse(JSON.stringify(data.data));
      }
      return [];
    },
    pathUrl() {
      return this.pathRouter.map((path, i) => {
        if (i) {
          return {
            name: path.split("/").pop(),
            path
          };
        }
        return {
          name: path,
          path
        };
      });
    }
  },
  methods: {
    pageTrun(index) {
      this.page.pageIndex = index;
      if (
        !this.queryData[
          `${this.rootPath}_${this.filterValue}_${this.page.pageIndex}`
        ]
      ) {
        this.getFileData(this.rootPath);
      }
    },
    rowClick(row) {
      this.page.pageIndex = 1;
      this.filterForm.value = this.filterValue = "";
      this.page.hasMore = false;
      if (
        !this.queryData[`${row}_${this.filterValue}_${this.page.pageIndex}`]
      ) {
        this.getFileData(row);
      } else {
        this.rootPath = row;
      }
    },
    rootClick(row) {
      this.pathRouter = [row];
      this.rowClick(row);
    },
    folderClick(row) {
      this.pathRouter.push(row);
      this.rowClick(row);
    },
    pathClick(path, i) {
      if (i !== this.pathRouter.length - 1) {
        let index = this.pathRouter.indexOf(path);
        this.pathRouter.splice(index + 1);
        this.rowClick(path);
      }
    },
    getPathData(path) {
      this.$http.get("gavial/v1/file/view/paths").then(res => {
        this.pathData = paging(res.data.data);
        this.selectPath(path);
      });
    },
    // 加载列表后，根据 path 情况选择默认值
    selectPath(path) {
      if (!path) {
        this.listPage = 0;
        // 设置选中项
        this.$refs.singleTable.setCurrentRow(this.pathData[0][0]);
      } else {
        let index = 0;
        let noFind = true;
        let rootPath = path
          .split("/")
          .slice(0, 4)
          .join("/");
        while (index < this.pathData.length && noFind) {
          let findex = this.pathData[index].findIndex(p => p === rootPath);
          if (findex > -1) {
            // 初始化 pageindex
            this.listPage = index;
            this.$nextTick(() => {
              this.choosePath(path);
            });
          }
          index++;
        }
      }
    },
    listTrun(pageIndex) {
      this.listPage = pageIndex - 1;
    },
    /*
     * 实现从 分类管理 => 文件浏览 跳转到对应文件夹
     */
    choosePath(path) {
      let newPath = path.split("/");
      /*
       * 修改rootPath 配合 queryDataReset() 方法清除清除queryData历史，
       * queryData存在缓存的 path 会直接读缓存
       * 防止缓存影响数据请求，导致前后端数据不一致。
       */
      this.rootPath = newPath.slice(0, 4).join("/");
      this.queryDataReset();
      // 清空过滤条件
      this.filterForm.value = this.filterValue = "";
      // 目录列表 选中对应的 rootPath
      this.$refs.singleTable.setCurrentRow(this.rootPath);
      let pathaArr = [];
      newPath.forEach((p, i) => {
        if (i > 2) {
          pathaArr.push(newPath.slice(0, i + 1).join("/"));
        }
      });
      // 路径路由手动拼接
      this.pathRouter = pathaArr;

      this.getFileData(path);
    },
    getFileData(rootPath) {
      this.loading = true;
      this.$http
        .get(
          `/gavial/v1/file/view/list?dir=${rootPath}&pageIndex=${this.page.pageIndex}&pattern=${this.filterValue}&limit=${this.page.limit}`
        )
        .then(res => {
          this.$set(
            this.queryData,
            `${rootPath}_${this.filterValue}_${this.page.pageIndex}`,
            res.data
          );
          this.page.hasMore = res.data.hasMore;
          this.page.pageIndex = res.data.pageIndex;
          this.rootPath = rootPath;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      this.filterValue = this.filterForm.value;
      this.page.hasMore = false;
      this.page.pageIndex = 1;
      this.getFileData(this.rootPath);
    },
    fileDownload(path, filename) {
      Download(
        `/gavial/v1/file/view/getFile?path=${encodeURIComponent(path)}`,
        filename
      );
    },
    fileDelete(path, filename, isDir) {
      if (!isDir) {
        Delete(
          `/gavial/v1/file/admin/deleteFile?path=${encodeURIComponent(
            path
          )}&recu=`,
          filename,
          this.refush,
          bool => {
            this.loading = bool;
          }
        );
      } else {
        DeletePrompt(
          `/gavial/v1/file/admin/deleteDir?dir=${encodeURIComponent(
            path
          )}&confirmDir=`,
          path,
          this.refush,
          bool => {
            this.loading = bool;
          }
        );
      }
    },
    queryDataReset() {
      let reg = new RegExp(this.rootPath);
      Object.keys(this.queryData).forEach(key => {
        if (reg.test(key)) {
          delete this.queryData[key];
        }
      });
      this.page.pageIndex = 1;
    },
    closeDialog() {
      this.newDialog = this.uploadDialog = false;
    },
    refush() {
      this.queryDataReset();
      this.getFileData(this.rootPath);
    },
    handleCommand(key, row) {
      switch (key) {
        case "copyPath":
          this.copyPath(row);
          break;
        case "del":
          this.fileDelete(row.path, row.filename, row.dir);
          break;
        case "d":
          this.fileDownload(row.path, row.filename);
          break;
      }
    },
    copyPath(row) {
      let clip = new Clipboard(".copy-button");

      clip.on("success", () => {
        this.$message({
          type: "success",
          message: "路径已复制"
        });
      });
      let button = document.createElement("button");
      button.className = "copy-button";
      button.setAttribute("data-clipboard-text", row.path);
      document.body.appendChild(button);
      button.click();
      document.body.removeChild(button);
      clip.destroy();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    piClick(key) {
      if (this.multipleSelection.length === 0) {
        return this.$message({
          type: "error",
          message: "请先选择需要操作的文件"
        });
      } else if (this.multipleSelection.length > 10) {
        return this.$message({
          type: "error",
          message: "批量操作文件个数不能超过10个"
        });
      }
      switch (key) {
        case "del":
          this.filesDelete();
          break;

        case "dwn":
          this.filesDownload();
          break;
      }
    },
    filesDelete() {
      let hasDir = this.multipleSelection.some(item => item.dir);
      if (hasDir) {
        return this.$message({
          type: "warning",
          message: "文件夹不支持批量删除！"
        });
      }
      let queryArr = this.multipleSelection.map(
        data =>
          `/gavial/v1/file/admin/deleteFile?path=${encodeURIComponent(
            data.path
          )}&recu=`
      );

      let nameArr = this.multipleSelection.map(data => {
        return `${data.filename}${data.dir ? "文件夹" : ""}`;
      });

      DeleteArr(queryArr, nameArr, this.refush, bool => {
        this.loading = bool;
      });
    },
    filesDownload() {
      this.multipleSelection.forEach((item, index) => {
        if (item.dir) return;
        Download(
          `/gavial/v1/file/view/getFile?path=${encodeURIComponent(item.path)}`,
          item.filename,
          index
        );
      });
    }
  },
  components: {
    "file-dialog": dialog
  }
};
</script>

<style lang="scss">
#file-brows {
  height: 100%;
  .content {
    display: flex;
    height: 100%;
  }
  .left-box {
    width: 270px;
    margin-right: var(--padding);
    .current-row .path-name {
      color: var(--blue);
    }
  }
  .filepath > div > span.path-name {
    display: inline;
    &:last-child {
      color: var(--blue);
    }
  }
  .right-box {
    width: calc(100% - 270px - var(--padding) * 3);
    background: #fff;
    padding: var(--padding);
  }
}
</style>
